import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { MimicsEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class MimicSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    mimicCreated$() {
        return this.socketService.receiveMessageObserver(MimicsEvents.MIMIC_CREATED);
    }

    mimicUpdated$() {
        return this.socketService.receiveMessageObserver(MimicsEvents.MIMIC_UPDATED);
    }

    mimicDeleted$() {
        return this.socketService.receiveMessageObserver(MimicsEvents.MIMIC_DELETED);
    }

    mimicUpdatedIndex$() {
        return this.socketService.receiveMessageObserver(MimicsEvents.MIMIC_INDEX_UPDATE);
    }
}
